<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div>
          <label class="label-input">Section Title</label>
          <v-text-field v-model="fields.title" label="Title" />
        </div>

        <div class="mt-6">
          <label class="label-input">Section Settings</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields['background-color']"
                  name="background-color"
                  label="Background Color"
                  default-color="#ffffff"
                />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields['text-color']"
                  name="text-color"
                  label="Text Color"
                  default-color="#000000"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox class="mt-0" v-model="fields.topPadding" label="Top padding" hide-details />
              </v-col>
              <v-col cols="12" md="3">
                <v-checkbox class="mt-0" v-model="fields.bottomPadding" label="Bottom padding" hide-details />
              </v-col>
              <v-col cols="12" md="12">
                <div class="mb-3">
                  <v-switch v-model="fields.enableContainerPage" label="Enable container page" hide-details />
                </div>
                <div v-show="fields.enableContainerPage">
                  <ColorPicker
                    v-model="fields.backgroundContainer"
                    name="background-container"
                    label="Background Container"
                    default-color="#ffffff"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mt-6">
          <label class="label-input">Title Card</label>
          <div class="group-item">
            <div class="mb-3">
              <v-checkbox v-model="fields['show-title']" label="Show title" hide-details class="mt-0 pt-0" />
            </div>
            <ckeditor :editor="editor" v-model="fields['title-card']" :config="editorConfig" />
          </div>
        </div>

        <div class="mt-6">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input mb-0">Slides</label>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add slide</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, index) in fields.listItem" :key="index">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center" style="width: 100%">
                  <span>Slide {{ index + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveItem(index)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-radio-group
                  row
                  dense
                  :value="item.mediaType || 'video'"
                  @change="val => handleChangeMediaType(index, val)"
                >
                  <v-radio label="Video" value="video" />
                  <v-radio label="Image" value="image" />
                </v-radio-group>
                <v-text-field
                  v-if="(item.mediaType || 'video') === 'video'"
                  v-model="item.videoItem"
                  label="Video URL"
                  @input="handleSyncMediaSource(index, 'video')"
                />
                <video
                  v-if="(item.mediaType || 'video') === 'video' && item.videoItem"
                  :src="item.videoItem"
                  controls
                  muted
                  playsinline
                  style="max-width: 220px; border-radius: 10px; display: block"
                />

                <div v-if="(item.mediaType || 'video') === 'image'">
                  <UploadImage
                    @callback="obj => handleUploadImage(obj, index)"
                    :image="{ imageSrc: item.imageItem }"
                    :height="`220`"
                    :typeUpload="'image'"
                    @callbackDelete="() => handleRemoveImage(index)"
                  />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import ColorPicker from './common/color-picker.vue';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
export default {
  name: 'policy-yuri-videos-section-editor',
  components: {
    ColorPicker,
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Policy Yuri Videos Section',
        'title-card': '<h2>See it in action</h2><p>Experience the transformative power</p>',
        'show-title': true,
        'background-color': '#ffffff',
        'text-color': '#000000',
        enableContainerPage: true,
        topPadding: true,
        bottomPadding: true,
        listItem: [],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
      listItem: Array.isArray(this.sectionEditor.sectionExtract?.listItem)
        ? this.sectionEditor.sectionExtract.listItem.map(this.normalizeListItem)
        : this.fields.listItem,
    };
  },
  methods: {
    handleUploadImage(obj, index) {
      const item = this.fields.listItem[index];
      if (!item) return;
      item.imageItem = obj.imageSrc;
    },
    handleRemoveImage(index) {
      const item = this.fields.listItem[index];
      if (!item) return;
      item.imageItem = '';
    },
    normalizeListItem(item = {}) {
      const mediaType =
        item.mediaType === 'image'
          ? 'image'
          : item.mediaType === 'video'
          ? 'video'
          : item.imageItem
          ? 'image'
          : 'video';
      return {
        mediaType,
        videoItem: mediaType === 'video' ? item.videoItem || '' : '',
        imageItem: mediaType === 'image' ? item.imageItem || '' : '',
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.listItem.push({
        mediaType: 'video',
        videoItem:
          'https://yurikoreanbeauty.com/cdn/shop/videos/c/vp/0d1ebdb9a952408fa86482ff4aee51d8/0d1ebdb9a952408fa86482ff4aee51d8.HD-720p-1.6Mbps-57768546.mp4?v=0',
        imageItem: '',
      });
    },
    handleChangeMediaType(index, value) {
      const item = this.fields.listItem[index];
      if (!item) return;
      item.mediaType = value === 'image' ? 'image' : 'video';
      if (item.mediaType === 'video') {
        item.imageItem = '';
      } else {
        item.videoItem = '';
      }
    },
    handleSyncMediaSource(index, mediaType) {
      const item = this.fields.listItem[index];
      if (!item) return;
      item.mediaType = mediaType === 'image' ? 'image' : 'video';
      if (item.mediaType === 'video') {
        item.imageItem = '';
      } else {
        item.videoItem = '';
      }
    },
    handleRemoveItem(index) {
      this.fields.listItem.splice(index, 1);
    },
    handleSave() {
      const payload = {
        ...this.fields,
        listItem: (this.fields.listItem || []).map(item => ({
          mediaType: item.mediaType === 'image' ? 'image' : 'video',
          videoItem: item.mediaType === 'image' ? '' : item.videoItem || '',
          imageItem: item.mediaType === 'image' ? item.imageItem || '' : '',
        })),
      };
      const updateHtml = updateHtmlFromData.sectionPolicyYuriVideos(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.ck-editor__editable_inline {
  min-height: 220px;
}
.ck-editor__editable {
  min-height: 220px;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
